import { RootState } from "../../store/types";
import { AppDispatch } from "../../store";
import { connect } from "react-redux";
import VolumesAndWip from "./index";
import { getTargetAndWipVolumeThunk, verifyVolumesThunk } from "../../store/slices/volumesAndWipSlice";
import { resetShiftPlanOutput } from "../../store/slices/reviewAndPublishSlice";
import { GetTargetAndWIPVolumeRequest } from "./model";

const mapStateToProps = (state: RootState) => ({
    targetAndWIPVolume: state.volumesAndWip.targetAndWIPVolume,
    planId: state.shiftPlan.planId,
    date: state.shiftPlan.selectedDate,
    shiftType: state.shiftPlan.selectedShift,
    stationCode: state.shiftPlan.stationCode
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    getTargetAndWipVolume: (getTargetAndWipVolumeRequest: GetTargetAndWIPVolumeRequest) =>
        dispatch(getTargetAndWipVolumeThunk(getTargetAndWipVolumeRequest)),
    verifyVolumes: async (planId: string, processPathOverrides?: any) => 
        await dispatch(verifyVolumesThunk({ planId, processPathOverrides })),
    resetShiftPlanOutput: () => dispatch(resetShiftPlanOutput())
});

export default connect(mapStateToProps, mapDispatchToProps)(VolumesAndWip);
